import BaseUseCase from "../base_use_case.js.jsx";
import GwtTokenStorage from "../../utils/gwt_token_storage.js";
class UpdatePasswordUseCase extends BaseUseCase {

  execute(params) {
    GwtTokenStorage.clear();
    return this.httpClient({
      ...this.requestConfig(),
      method: "put",
      url: `/api/v1/passwords`,
      data: this.wrapParams(params, "user")
    }).then((result) => {
      const { headers: { authorization } } = result;
      GwtTokenStorage.store(authorization);
      return result;
    });
  }
}

const instance = new UpdatePasswordUseCase();
export default instance;